'use client'

import { Check } from 'lucide-react'

import { rootVariants } from '~/components/component-library/Checkbox/styles'
import { type CheckboxProps } from '~/components/component-library/Checkbox/types'
import { cn } from '~/utils/tailwind-utils'

export { type CheckboxProps } from '~/components/component-library/Checkbox/types'

// The Checkbox here is purely decorative — the parent row owns interaction
// and accessibility (role="checkbox", aria-checked, onClick). We render a
// plain div instead of @radix-ui/react-checkbox because Radix's internal
// Presence component triggers a ref-callback setState during commit-phase
// ref-detach which causes a "Maximum update depth exceeded" infinite loop
// in React 19 (reproducible in InvitePayeeDialog).
export const Checkbox = ({
  isChecked,
  id,
  isDisabled = false,
}: CheckboxProps) => (
  <div
    id={id}
    aria-hidden
    className={cn(rootVariants({ isChecked, isDisabled }))}
  >
    <Check
      className={cn('size-2.5 text-white transition-transform duration-100', {
        'scale-100': isChecked,
        'scale-0': !isChecked,
      })}
      strokeWidth={4}
    />
  </div>
)
